<template>
    <footer class="bg-dark pt-5">
        <div class="container">
            <div class="row">
                <div class="col-md mb-4">
                    <a href="" class="inline-block">
                        <img src="@/assets/img/logo.png" alt="image" width="50px">
                    </a>
                </div>
                <div class="col-md-3 mb-5">
                    <p class="text-white">
                        Es-tu un footballeur ? occasionnel ou compétitif, <b>6v6foot</b> est le bon endroit pour que tout le monde rejoigne la communauté,
                        inscrivez-vous, choisissez votre terrain préféré et crèez votre propre match.
                    </p>
                </div>
                <div class="col-md-2 mb-5">
                    <h3 class="font-weight-500 text-xl text-white mb-2"><span class="text-primary">A</span>ccès rapide</h3>
                    <span class="d-block"><a href="" class="ml-1 text-sm text-white">Accueil</a></span>
                    <span class="d-block"><a href="/contact" class="ml-1 text-sm text-white">Contact</a></span>
                    <span class="d-block"><a href="/login" class="ml-1 text-sm text-white">Se connecter</a></span>
                    <span class="d-block"><a href="/register" class="ml-1 text-sm text-white">S'inscrire</a></span>
                    <span class="d-block"><a href="/become-partner" class="ml-1 text-sm text-white">Devenir partenaire</a></span>
                </div>
                <div class="col-md-3 mb-5">
                    <h3 class="font-weight-500 text-xl text-white mb-2"><span class="text-primary">P</span>olitiques et questions</h3>
                    <span class="d-block"><a href="/faq" class="ml-1 text-sm text-white">FAQ</a></span>
                    <span class="d-block"><a href="/cgu" class="ml-1 text-sm text-white">Conditions Générales d'Utilisation</a></span>
                    <span class="d-block"><a href="/privacy-policy" class="ml-1 text-sm text-white">Politique de Confidentialité</a></span>
                </div>
                <div class="col-md-3 text-white">
                    <h3 class="font-weight-500 text-xl text-white mb-2"><span class="text-primary">C</span>ontact</h3>
                    <p><i class="fas fa-map-marker-alt mr-2"></i> 46, Rue de la Joie, Nouvelle Médina - Ben Arous, 2063</p>
                    <p><i class="fas fa-phone mr-1"></i> <a href="tel:0021695654666" class="text-white">+21695654666</a></p>
                    <p><i class="fas fa-at mr-1"></i> <a href="mailto:contact@6v6foot.com" class="text-white">contact@6v6foot.com</a></p>
                </div>
                <div class="col-md-12 pt-5 pb-2">
                    <p class="text-white text-center text-xs">Copyright @ 2025 6v6foot</p>
                </div>
            </div>
        </div>
    </footer>
</template>